
import Vue from  'vue'
import { getBounds } from '../../utils/dom/pos.js'

const SUPPORT_TOUCH = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)
/*const EVENT_START = SUPPORT_TOUCH ? 'touchstart' : 'mousedown'
const EVENT_END = SUPPORT_TOUCH ? 'touchend' : 'mouseup'
const EVENT_MOVE = SUPPORT_TOUCH ? 'touchmove' : 'mousemove'*/


// Android optimization
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
let SUPPORT_PASSIVE = false;
try {
  const opts = Object.defineProperty({}, 'passive', {
    get: function() { SUPPORT_PASSIVE = true }
  })
  window.addEventListener("test", null, opts)
} catch (e) {}
const LISTENER_OPTIONS = SUPPORT_PASSIVE ? {passive : true} : false




/*
            TODO

    Touche: Use pageX/Y substract current position to have good value object
*/


export default {

    data()
    {
        return {
            width: null,
            height: null,
            last: {},
        }
    },

    props: {

        listenX: { type: Boolean, default: true },
        listenY: { type: Boolean, default: true },

        // Optional value object used to transit data from parent to child:
        // <parent> -> <core-drag-area> -> <child>
        data: Object
    },

    created()
    {
        this._onStartDrag = this._onStartDrag.bind(this)
        this._onStopDrag = this._onStopDrag.bind(this)
        this._onUpdateDrag = this._onUpdateDrag.bind(this)
        this._onMouseMove = this._onMouseMove.bind(this)
    },

    mounted()
    {
        if (SUPPORT_TOUCH)
        {
            this.$el.addEventListener('touchstart', this._onStartDrag, LISTENER_OPTIONS)
        }
        else
        {
            this.$el.addEventListener('mousedown', this._onStartDrag, LISTENER_OPTIONS)
        }

        this._checkSize()
    },

    destroyed()
    {
        if (SUPPORT_TOUCH)
        {
            this.$el.removeEventListener('touchstart', this._onStartDrag)
        }
        else
        {
            this.$el.removeEventListener('mousedown', this._onStartDrag)
        }
    },

    methods: {

        _checkSize()
        {
            const { x, y, w, h } = getBounds(this.$el)
            this.x = x
            this.y = y
            this.width = w
            this.height = h
        },

        _onStartDrag( event )
        {
            this._checkSize()
            const bodyElmt = window.document.body


            if (SUPPORT_TOUCH)
            {
                bodyElmt.addEventListener('touchend', this._onStopDrag, LISTENER_OPTIONS )
                bodyElmt.addEventListener('mouseout', this._onStopDrag, LISTENER_OPTIONS )
                bodyElmt.addEventListener('touchmove', this._onMouseMove, LISTENER_OPTIONS )
            }
            else
            {
                bodyElmt.addEventListener('mouseup', this._onStopDrag, LISTENER_OPTIONS )
                bodyElmt.addEventListener('mouseout', this._onStopDrag, LISTENER_OPTIONS )
                bodyElmt.addEventListener('mousemove', this._onMouseMove, LISTENER_OPTIONS )
            }


            this._onUpdateDragRAF = requestAnimationFrame(this._onUpdateDrag.bind(this))

            this._lastEvent = event

            const vo = this._getVo(event)
            this.$emit('drag:start', vo)
            this.last = vo
        },

        _onMouseMove( event )
        {
            this._lastEvent = event
        },

        _onUpdateDrag( event )
        {
            this._onUpdateDragRAF = requestAnimationFrame(this._onUpdateDrag.bind(this))

            const vo = this._getVo(this._lastEvent)
            const { x, y } = this.last

            if (vo.x !== x || vo.y !== y)
            {
                this.last = vo
                this.$emit('drag:update', vo)
            }

        },

        _onStopDrag( event )
        {
            if (event.type == 'mouseout')
            {
                if (event.relatedTarget && event.relatedTarget.nodeName != 'HTML')
                {
                    return
                }
            }

            const bodyElmt = window.document.body

            cancelAnimationFrame(this._onUpdateDragRAF)

            if (SUPPORT_TOUCH)
            {
                bodyElmt.removeEventListener('touchend', this._onStopDrag )
                bodyElmt.removeEventListener('mouseout', this._onStopDrag )
                bodyElmt.removeEventListener('touchmove', this._onMouseMove )
            }
            else
            {
                bodyElmt.removeEventListener('mouseup', this._onStopDrag )
                bodyElmt.removeEventListener('mouseout', this._onStopDrag )
                bodyElmt.removeEventListener('mousemove', this._onMouseMove )
            }

            const vo = this._getVo( event.type == 'touchend' ? this._lastEvent : event )
            this.$emit('drag:stop', vo)
            this.last = vo
        },

        _getVo( event )
        {
            let x, y, u, v

            const touch = ['touchmove', 'touchstart'].indexOf(event.type) > -1
            const w = this.width,
                  h = this.height

            // const touch = this._getTouchEvent( event )

            if (this.listenX)
            {
                if (touch)
                {
                    x = event.touches[0].pageX - this.x
                }
                else
                {
                    x = (event.layerX !== null) ? event.layerX : (event.offsetX !== null) ? event.offsetX : 0
                }

                x = (x > w) ? w : (x < 0) ? 0 : x
                u = x / w
            }

            if (this.listenY)
            {
                if (touch)
                {
                    y = event.touches[0].pageY - this.y
                }
                else
                {
                    y = (event.layerY !== null) ? event.layerY : (event.offsetY !== null) ? event.offsetY : 0
                }

                y = (y > h) ? h : (x < 0) ? 0 : y
                v = y / h
            }

            return { x, y, u, v }
        },

        /*_getTouchEvent( event )
        {
            return event.touches !== null ? event.touches[0] : null
        }*/

        /*_updateAndEmit()
        {

            this.pause();
            this.$el.classList.add('is-seeking');
            this._winWidth = window.innerWidth;
            this._width = this.$el.offsetWidth;
            this._mouseX = event.clientX - (this._winWidth - this._width) * .5;

            this.currentTimelineValue = (this._mouseX / this._width);
            console.log('onSeek', this.currentTimelineValue)

            setTimeout( () => {
                // this.$player.currentTime = this.currentTimelineValue * this._duration;
                // this.play();
            }, 100)

            clearTimeout(this._seekingTimer);
            this._seekingTimer = setTimeout( () => {
                // this.$el.classList.remove('is-seeking');
            }, 800)

        }*/
    }

}
